// templates.ts
export interface ReclamationTemplate {
  id: string;
  type?: string;
  reason?: string;
  content?: string;
}

export const templates: ReclamationTemplate[] = [
  {
    id: "Demande_habilitations_myTelephony",
    type: "technical",
    reason: "technique_demande_information",
    content: `BU : {buId} - Demande habilitations myTelephony \n
Prestation : {serviceId} - {serviceName}\n
Bonjour,\n
Je souhaiterais être habilité à la plateforme de gestion de la téléphonie HD, myTelephony.\n
Je vous en remercie par avance.\n`
  },
  {
    id: "demande_de_changement_de_musique_d_attente",
    type: "technical",
    reason: "technique_demande_information",
    content: `Téléphonie : demande de changement de musique d'attente
    
BU : {buId}
Contact: {nom} {prenom} ({id})
User: {email}

Bonjour,\n
Je souhaite paramétrer ma musique d'attente avec le morceau suivant : {music}\n
Merci.`},
{
    id: "Demande_de_creation_d_une_nouvelle_base_de_donnees",
    type: "technical",
    reason: "technique_demande_information",
    content: `Demande de création d'une nouvelle base de données
Identifiant BU : {buId}`
  },
{
    id: "Demande_recharge_ligne_mobile_4G",
    type: "technical",
    reason: "technique_config_router",
    content: `Demande recharge ligne mobile 4G
Identifiant BU : {buId}
Id CIS : {ficheId}

L'utilisateur {email}  vient de faire une demande de recharge de la data pour la ligne : 
{msisdn} .
Recharge demandée : {volume} Go.
Ceci est un mail automatique envoyé via l'Espace Clients.
`
  }
];
